const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

export const API_BASE_URL = (
  configuredBaseUrl || "https://api.cbva.co.za"
).replace(/\/$/, "");

export const apiUrl = (path: string): string =>
  `${API_BASE_URL}/${path.replace(/^\//, "")}`;
